<template>
  <div class="flex flex-col">
    <div class="flex items-center justify-end">
      <div class="inline-flex shadow-md hover:shadow-lg focus:shadow-lg" role="group">
        <button
          :disabled="isSearching || !canGoBack()"
          type="button"
          class="disabled rounded-l inline-block px-6 py-2.5 bg-white text-gray-500 font-medium text-xs leading-tight uppercase hover:bg-gray-100"
          @click="goPreviousPage()"
        >
          <i class="fas fa-chevron-left" />
        </button>
        <button
          :disabled="true"
          type="button"
          class="cursor-auto inline-block px-3 py-2.5 bg-white text-gray-500 font-medium text-xs leading-tight uppercase"
        >
          ( {{ currentRangeStart }} - {{ currentRangeEnd }} ) of {{ total }}
        </button>
        <button
          :disabled="isSearching || !canGoNext()"
          type="button"
          class="rounded-r inline-block px-6 py-2.5 bg-white text-gray-500 font-medium text-xs leading-tight uppercase hover:bg-gray-100"
          @click="goNextPage()"
        >
          <i class="fas fa-chevron-right" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from 'vue'
import router from '@/router'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

export default {
  name: 'ListViewPagination',
  props: {
    isSearching: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    const store = useStore()

    const adjustOffset = ref(1)

    const response = computed(() => {
      return store.getters['Resources/currentResponse']
    })

    const request = computed(() => {
      return store.getters['Resources/currentRequest']
    })

    const total = computed(() => {
      return response.value.total
    })

    const currentRangeStart = computed(() => {
      const rangeStart = response.value.offset + 1
      return rangeStart > total.value ? 1 : rangeStart
    })

    const currentRangeEnd = computed(() => {
      const r = response.value
      const computedEnd = currentRangeStart.value + Number(r.limit) - 1
      if (computedEnd < 0) return 0
      if (computedEnd > r.total) return r.total
      return computedEnd
    })

    function canGoBack() {
      return response.value.offset >= response.value.limit
    }

    function canGoNext() {
      const r = response.value
      const remainder = r.total - request.value.Offset
      return remainder > r.limit
    }

    function goNextPage() {
      const currentRequest = request.value
      currentRequest.Offset = Number(currentRequest.Offset) + Number(currentRequest.Limit)
      store.dispatch('Resources/search', currentRequest)
    }
    function goPreviousPage() {
      const currentRequest = request.value
      currentRequest.Offset = Number(currentRequest.Offset) - Number(currentRequest.Limit)
      store.dispatch('Resources/search', currentRequest)
    }
    return { currentRangeStart, currentRangeEnd, total, goPreviousPage, goNextPage, canGoNext, canGoBack }
  },
}
</script>

<style scoped>

</style>
